import "./DoctorConfirmModalFooter.scss";

type DoctorConfirmModalFooterProps = {
  children?: React.ReactNode;
};

export const DoctorConfirmModalFooter = ({
  children,
}: DoctorConfirmModalFooterProps) => {
  return (
    <footer className="ui-consent-modal-footer bg-white shadow">
      {children}
    </footer>
  );
};
